module.exports = __webpack_public_path__ + "fonts/NeutraTextLightAlt.3733bfc9.otf";